import React, { useEffect, useState } from "react";
import { ClockIcon, FlameIcon } from "lucide-react";
import { TOTAL_CUPOS } from "../data/constants";
function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownOffer() {
  // Countdown from a fixed offset that resets each visit-day
  const [remaining, setRemaining] = useState(() => {
    const stored = Number(sessionStorage.getItem("cir_deadline"));
    if (stored && stored > Date.now()) return stored - Date.now();
    const deadline = Date.now() + 1000 * 60 * 47 + 1000 * 33; // ~47m 33s
    sessionStorage.setItem("cir_deadline", String(deadline));
    return deadline - Date.now();
  });
  const cuposLeft = 27; // limited spots remaining out of 200
  const pct = Math.round(cuposLeft / TOTAL_CUPOS * 100);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(r => r > 1000 ? r - 1000 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const totalSec = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor(totalSec % 3600 / 60);
  const seconds = totalSec % 60;
  return <div className="rounded-2xl border border-gold/40 bg-cream p-4" data-id="element-67" data-mp="3fwqwywexe939">
      <div className="flex items-center justify-center gap-2 text-italian-green" data-id="element-68" data-mp="3tncg8m8akl1o">
        <FlameIcon className="h-5 w-5" aria-hidden="true" data-id="element-69" data-mp="3pmk5fojru83a" />
        <p className="text-sm font-bold uppercase tracking-wide" data-id="element-70" data-mp="3pp6ddpakqpm1">
          La oferta termina en
        </p>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-71" data-mp="2wyelv54gep51">
        {[{
        v: hours,
        l: "hs"
      }, {
        v: minutes,
        l: "min"
      }, {
        v: seconds,
        l: "seg"
      }].map((unit, i) => <React.Fragment key={unit.l} data-id="element-72" data-mp="35yjs3bxwvhhm" data-mpi={i}>
            <div className="flex w-16 flex-col items-center rounded-xl bg-italian-green py-2 text-cream" data-id="element-73" data-mp="35xi303k28ugw">
              <span className="font-serif text-2xl font-bold tabular-nums" data-id="element-74" data-mp="q9rv1aeb2npw">
                {pad(unit.v)}
              </span>
              <span className="text-[10px] uppercase opacity-80" data-id="element-75" data-mp="3f0k8xiiynkvj">{unit.l}</span>
            </div>
            {i < 2 && <span className="font-serif text-2xl text-italian-green" data-id="element-76" data-mp="3jyvmo4cdmfj1">:</span>}
          </React.Fragment>)}
      </div>

      <div className="mt-4" data-id="element-77" data-mp="3o21n2vct5chl">
        <div className="mb-1 flex items-center justify-between text-xs font-semibold text-ink/70" data-id="element-78" data-mp="3t0cwj4z6xkza">
          <span className="flex items-center gap-1" data-id="element-79" data-mp="2wa2o004ddtkq">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-80" data-mp="2wbngzlb1d4gh" />
            Cupos restantes
          </span>
          <span className="text-italian-green" data-id="element-81" data-mp="30bxjup3j7er4">
            {cuposLeft} / {TOTAL_CUPOS}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-sand" data-id="element-82" data-mp="358xs96nustle">
          <div className="h-full rounded-full bg-gold transition-all" style={{
          width: `${Math.max(pct, 6)}%`
        }} data-id="element-83" data-mp="3a322pzwbvjr8" />
        </div>
        <p className="mt-1 text-center text-[11px] text-ink/60" data-id="element-84" data-mp="2hkejyr4t0gtb">
          Quedan pocos cupos a este precio
        </p>
      </div>
    </div>;
}